import React, { Component } from 'react';
import Presets from 'components/selector2/presets/Presets.js';

class PresetsDocumentation extends Component {
    render() {
        return (
            <div>
              <p>
                If can take a while to find the right sounds and settings, and treat them in a way
                that you like. <b>Presets</b> help you save time by saving settings that may have worked
                in a previous project.
              </p>
              <p>
                <b>Presets</b> are saved sound or instrument settings that can be quickly loaded into a track.
              </p>
             <p className="sub-header">
                Loading Presets
              </p>
              <p>
                You can view presets by going to the <b>Presets</b> tab on the sidebar. 
                <div className="presets-demo-container">
                  <Presets sequencerEngine={this.props.sequencerEngine}/>
                </div>
              </p>
              <p>
                Presets are broken up by day in this view. Click on a day to see all the presets made on that day.
              </p>
              <p>
                To add a preset to your project, click on the colored circle to the right of a preset. You can
                also drag it into an existing track to replace that track with the preset.
              </p>
              <p className="sub-header">
                Saving Presets
              </p>
              <p>
                <ol>
                  <li>
                    Right-click on the track you wish to save as a preset,
                    and from the dropdown menu, press “Save Preset”. 
                  </li>
                  <li>
                    A pop-up will be shown, where you type the name of your preset.
                  </li>
                  <li>
                    Hit save.
                  </li>
                </ol>
              </p>
            </div>
        );
    }
}

export default PresetsDocumentation;
